import {
    PRODUCTION_REGISTER_SIZING_REPORT_REQUEST,
    PRODUCTION_REGISTER_SIZING_REPORT_SUCCESS,
    PRODUCTION_REGISTER_SIZING_REPORT_FAILURE,
    PRODUCTION_REGISTER_SIZING_FILTER_REPORT_REQUEST,
    PRODUCTION_REGISTER_SIZING_FILTER_REPORT_SUCCESS,
    PRODUCTION_REGISTER_SIZING_FILTER_REPORT_FAILURE
  } from "../types/production-register-sizing-report-types";
  
  const initialState = {
    productionSizingReports: {},
    loading: false,
    error: null,
  };
  
  const productionSizingReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case PRODUCTION_REGISTER_SIZING_REPORT_REQUEST:
      case PRODUCTION_REGISTER_SIZING_FILTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case PRODUCTION_REGISTER_SIZING_REPORT_SUCCESS: {
        console.log('Reducer: PRODUCTION_REGISTER_SIZING_REPORT_SUCCESS', {...(action.payload || {})});
        return {
          ...state,
          productionRegisterSizingReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case PRODUCTION_REGISTER_SIZING_FILTER_REPORT_SUCCESS: {
        return {
          ...state,
          productionRegisterSizingFilterReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case PRODUCTION_REGISTER_SIZING_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default productionSizingReportReducer;
  